export default "<footer>\n  <div class=\"container\">\n    <div class=\"copyright\">\n      <div>Designed by RSGiTECH</div>\n    </div>\n  </div>\n</footer>"